<template>
  <div class="card">
    <div class="card-body" ref="searchBox">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1 class="title">시험지 관리</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableTotal}}</span></strong> 건
        </div>
        <div class="ml-auto p-2">
          <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading"></excel>
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="search.search_text" @keyup.enter="retrieve" placeholder="시험지명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>

    </div>

    <stone-data-table-server
      ref="dataTableServer"
      table-ref="dataTableServer"
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @query-change="tableLoadData"
      @row-click="rowClickHandler">
    </stone-data-table-server>

  </div>
</template>
<script>
import common from '@/modules/common'
export default {
  name: 'M040101',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableTotal: 0,
      tableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 60, sortable: false},
        // {label: '시험지번호', prop: 'exam_paper_seq', align: 'left', width: 70},
        {label: '유형', prop: 'exam_paper_type_name', align: 'center', width: 70},
        {label: '시험지명', prop: 'title', align: 'left', width: 150},
        {label: '카테고리', prop: 'cate_code_name', align: 'center', width: 100},
        {label: '교재', prop: 'book_name', align: 'left', width: 100},
        {label: '회차', prop: 'times', align: 'center', width: 70},
        {label: '문제수', prop: 'quiz_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 70},
        {label: '총점', prop: 'quiz_score', align: 'right', formatter: this.columnFormatterNumber, width: 70},
        {label: '생성일', prop: 'reg_dt', align: 'center', formatter: this.columnFormatterDate, width: 100, dataType: 'date', format: 'yyyy.MM.dd'}
      ],
      search: {
        search_text: '',
        title: '',
        exception_paper_type: 'note'
      },
      isPageLoadInit: true,
      queryParam: {},
      isCurrentPage: false
    }
  },
  beforeCreate () {
  },
  created () {
    this.retrieveDummy()
  },
  mounted () {
  },
  methods: {
    retrieve () {
      const queryInfo = {page: 1, pageSize: 20, type: 'init', filters: [], sort: {}}
      this.tableLoadData(queryInfo)
      this.$refs.dataTableServer.localCurrentPage = 1
    },
    async tableLoadData (queryInfo, isClear = false) {
      if (this.checkedPageLoadInit(queryInfo)) {
        return
      }
      const param = Object.assign({query: queryInfo}, this.search)
      // console.log('param : ', param)
      this.loadStoneDataTable('/paper/list', param, true, false)
        .then(response => {
          this.tableData = response.data
          this.tableTotal = this.tableData && this.tableData.length > 0 ? this.tableData[0].total_count : 0
          this.setQueryParamPaging(isClear)
        })
    },
    goEdit (examPaperSeq) {
      const routerName = 'M040102'
      const param = {
        exam_paper_seq: examPaperSeq
      }
      this.routerPageChangeServer(routerName, param)
    },
    rowClickHandler (row, event, column) {
      this.goEdit(row.exam_paper_seq)
    },
    downloadExcel () {
      const param = {
        data: {
          service: 'ExamPaperService',
          method: 'retrieve',
          params: this.search
        },
        excel: {
          columns: this.tableColumns,
          file: '시험지관리'
        }
      }
      this.exportExcel(param)
    },
    onPopStateEventHandler () {
      if (this.$store.getters.page_params.query_info) {
        this.$route.params.query_info = this.$store.getters.page_params.query_info
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M040101.vue